"use strict";
exports.__esModule = true;
exports.TYPES = void 0;
exports.TYPES = {
    EDUCATION: "#3BC3B7",
    INTERNSHIP: "#DBA507",
    IT_WORK: "#007bff",
    SCHOOL: "#28a745"
};
